import React from "react";
import {Link, NavLink} from "react-router-dom";
import {Logo} from "../../images";

const TopNav = () => {
    return (
        <div className="mb-4 news-nav-top">
             <nav className="navbar navbar-expand navbar-light border-bottom mb-1 mt-2">
                <div className="container">
                    <div>
                        <Link to="/"><Logo /></Link><span className="headline d-none d-lg-inline-block">News and information from volunteer computing projects</span>
                    </div>
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <NavLink exact to="/"></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink activeClassName="active" className="nav-link" exact to="/news">News</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink activeClassName="active" className="nav-link" exact to="/projects">Projects</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink activeClassName="active" className="nav-link" exact to="/about">About</NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
            <div className="border-bottom"></div>
        </div>
    )
}

export default TopNav